import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { SelectImageData } from "../../../utils/common";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);

  const [product, setDesign] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetAllDesign = async () => {
    const response = await getData("/common/masters/design");

    if (response?.success) {
      setDesign(await Select2Data(response?.data, "design_id"));
    }
  };

  useEffect(() => {
    GetAllDesign();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    watch,
    getValues,
  } = useForm();

  const watchQuantitys = watch("quantitys"); // watches the entire array

  const totalQuantity =
    watchQuantitys?.reduce((sum, item) => {
      const qty = parseFloat(item?.quantity);
      return sum + (isNaN(qty) ? 0 : qty);
    }, 0) || 0;

    
  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("total_quantity", totalQuantity);
      const variants = [];
      data.quantitys.forEach((val, index) => {
        variants.push({
          design_id: val?.design_id?.value,
          quantity: val.quantity,
        });
      });

      DataToSend.append("quantitys", JSON.stringify(variants));

      const response = await postData(
        `/admin/purchase-order/purchase-product`,
        DataToSend
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "quantitys",
  });

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Purchase Order
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
            // className="stateclass"
          >
            <Row>
              <div className="oder-detail-holder mb-3">
                <div className="heading-holder">
                  <h6> Purchase Quanitity</h6>
                </div>

                <div className="package-details-section">
                  {fields.map((variant, index) => (
                    <div key={variant.id} className="main-form-section mt-3">
                      <Row>
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Design</Form.Label>
                              <Form.Group>
                                <Controller
                                  name={`quantitys.${index}.design_id`} // name of the field
                                  {...register(
                                    `quantitys.${index}.design_id`,
                                    {
                                      required: "Select Design",
                                    }
                                  )}
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      styles={{
                                        control: (baseStyles) => ({
                                          ...baseStyles,
                                          borderColor: errors?.add_on?.[index]
                                            ?.design_id
                                            ? "red"
                                            : baseStyles,
                                        }),
                                      }}
                                      {...field}
                                      options={product}
                                    />
                                  )}
                                />
                                {errors?.quantitys?.[index]?.design_id && (
                                  <span className="text-danger">
                                    {errors.quantitys[index].design_id.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Quanitity</Form.Label>
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  name={`quantitys.${index}.quantity`} // Register color for the variant
                                  placeholder="Quanitity"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.quantitys?.[index]?.quantity,
                                  })}
                                  {...register(`quantitys.${index}.quantity`, {
                                    required: "Quanitity is required",
                                  })}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "Backspace" ||
                                      e.key === "ArrowLeft" ||
                                      e.key === "ArrowRight"
                                    ) {
                                      return; // Allow the action to continue
                                    }

                                    // Allow digits and decimal point
                                    if (!/[\d.]/.test(e.key)) {
                                      e.preventDefault(); // Block the invalid key
                                    }

                                    if (
                                      e.key === "." &&
                                      e.target.value.includes(".")
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {errors?.quantitys?.[index]?.quantity && (
                                  <span className="text-danger">
                                    {errors.quantitys[index].quantity.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                      {fields.length > 1 && (
                        <button
                          className="mt-3 add-varient"
                          type="button"
                          onClick={() => remove(index)} // Remove the variant
                        >
                          Remove Design
                        </button>
                      )}
                      <hr />
                    </div>
                  ))}
                  <div>Total Quantity:{totalQuantity}</div>
                </div>
                <hr />
                <div className="text-center">
                  <button
                    type="button"
                    className="add-varient"
                    onClick={() => append({})}
                  >
                    + Add Design
                  </button>
                </div>
              </div>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
